import type { QueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/hooks/queryKeys";

// The Explorer header's Refresh action (Figma Bridge_Explorer 14899-263596):
// one press refetches everything the tree shows — the services and each
// service's resource list (both under the services prefix), the schema
// catalog and the stored test suites. Invalidation, not removal: rows keep
// rendering the cached tree while fresh data loads, and a stalled service's
// fetch restarts through the same query it was stuck on.
export function refreshExplorer(queryClient: QueryClient): Promise<void> {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: queryKeys.servicesRoot }),
    queryClient.invalidateQueries({ queryKey: queryKeys.schemasRoot }),
    queryClient.invalidateQueries({ queryKey: queryKeys.testSuites }),
  ]).then(() => undefined);
}
